const callbacks: LogFunc[] = [];

export const onLog = (cb: LogFunc) => {
  callbacks.push(cb);
};
export const offLog = (cb: LogFunc) => {
  const index = callbacks.indexOf(cb);
  if (index >= 0) {
    callbacks.splice(index, 1);
  }
};

export const emitLog = (data: LogData) => {
  if (process.env.NODE_ENV === 'development') {
    console.warn('警告：', data.message);
    console.warn('相关数据：', data.data);
  }
  callbacks.forEach((cb: LogFunc) => {
    cb(data);
  });
};
